export const StringUtils = {
  isBlank(str) {
    if (!str || str.trim() === '') return true;
    return false;
  },
  notIsBlank(str) {
    return !this.isBlank();
  }
}